<template>
  <b-form-select
    class="option_select"
    v-model="selected"
    @change="onChange"
    :options="options"
    size="sm"
    :state="selected !== null"
/>

</template>
<script>
import i18n from "@/shared/i18n";

export default {
  name: "CancelModalSelectComponent",
  props: {
    id: String
  },
  data() {
    return {
      selected: null,
      options: [
        {value: true, text: i18n.t('Yes')},
        {value: false, text: i18n.t('No')},
        {value: null, text: i18n.t('Select')}
      ],
      defaultChange: true
    }
  },
  methods: {
    onChange() {
      if (this.defaultChange) {
        this.options.pop()
        this.defaultChange = false
      }
      const data = {
        id: this.id,
        value: this.selected
      }
      this.$emit('getValue', data)
    }
  }
}
</script>


<style scoped lang="scss">
  .option_select {
    min-width: 70px;
  }
</style>
